import type { MarketDetailTab } from '@/lib/sdk/market-detail-tab-query';

export function shouldMountMarketDetailTabContent(
  activeTab: MarketDetailTab,
  isNearViewport: boolean,
): boolean {
  return isNearViewport || (activeTab !== 'debate' && activeTab !== 'winner');
}
